<template>
  <div v-if="getShowProduit">
    <div class="columns column is-multiline">
      <div class="map">
        <gmap-map
          :center="center"
          class="googleMap" ref="mapRef"
          @zoom_changed="updateZoom($event)"
          @tilesloaded="initPoi"
          :zoom="zoomCarto"
          :options="mapOptions">
            <gmap-marker
              v-for="(m, index) in getMarkerFaceLC"
              :key="index + 'faceLc'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarker(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerPanneauNumerique"
              :key="index + 'faceNum'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarker(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerPointAddress"
              :key="index + 'pointAddress'"
              :position="m.coordonnees"
              :icon="m.icon">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerFaceReseauxLc"
              :key="index + 'faceReseauLc'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarkerReseaux(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerFaceReseauxTempo"
              :key="index + 'faceReseauTempo'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarkerReseaux(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerFaceReseauxNumerique"
              :key="index + 'faceReseauNum'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarkerReseaux(m)">
            </gmap-marker>
            <gmap-marker
              v-for="(m, index) in getMarkerFaceReseauxPerso"
              :key="index + 'faceReseauPerso'"
              :position="m.position"
              :icon="m.icon"
              @click="selectMarkerReseaux(m)">
            </gmap-marker>
        </gmap-map>
      </div>
      <b-modal v-model="modalDetail"
               v-if="selectMarkerFace"
               has-modal-card
               class="modal">
        <info-window-map :marker="markerSelected"
                         @closeInfoWindow="markerSelected=''"/>
      </b-modal>
      <b-modal v-model="modalDetailReseaux"
               v-if="selectMarkerFaceReseaux"
               has-modal-card
               class="modal">
        <info-window-map-reseaux :marker="markerSelected"
                         @closeInfoWindow="markerSelected=''"/>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import { ZOOM_DEFAULT_LC, STYLE_MAPS_POI_HIDDEN, MAP_TYPE_CONTROL_OPTIONS, MAP_TYPE_NAME } from '@/configuration/carteConf';
import infoWindowMap from '@/components/creationOpportunite/panier/infoWindowMap';
import infoWindowMapReseaux from '@/components/creationOpportunite/panier/infoWindowMapReseaux';

const Panier = createNamespacedHelpers('panier');

export default {
  name: 'app-map',
  props: {
    tabValue: Number,
  },
  components: {
    infoWindowMap,
    infoWindowMapReseaux,
  },
  data() {
    return {
      circleBounds: '',
      modalDetail: false,
      modalDetailReseaux: false,
      markerSelected: null,
      selectMarkerFace: false,
      selectMarkerFaceReseaux: false,
      mapOptions: {
        mapTypeControlOptions: MAP_TYPE_CONTROL_OPTIONS,
      },
    };
  },
  computed: {
    ...Panier.mapGetters({
      getMarkerFaceLC: 'markerFaceLC',
      getMarkerPanneauNumerique: 'markerPanneauNumerique',
      getMarkerPointAddress: 'markerPointAddress',
      getZoomCarto: 'zoomCarto',
      getMarkerFaceReseauxLc: 'markerFaceReseauxLc',
      getMarkerFaceReseauxTempo: 'markerFaceReseauxTempo',
      getMarkerFaceReseauxNumerique: 'markerFaceReseauxNumerique',
      getMarkerFaceReseauxPerso: 'markerFaceReseauxPerso',
      getShowProduit: 'showProduit',
    }),
    zoomCarto: {
      get() {
        return ZOOM_DEFAULT_LC;
      },
      set(value) {
        this.setZoomCarto(value);
      },
    },
    center() {
      if (this.getMarkerFaceLC.length) {
        return this.getMarkerFaceLC[0].position;
      }
      if (this.getMarkerPanneauNumerique.length) {
        return this.getMarkerPanneauNumerique[0].position;
      }
      if (this.getMarkerFaceReseauxLc.length) {
        return this.getMarkerFaceReseauxLc[0].position;
      }
      if (this.getMarkerFaceReseauxTempo.length) {
        return this.getMarkerFaceReseauxTempo[0].position;
      }
      if (this.getMarkerFaceReseauxNumerique.length) {
        return this.getMarkerFaceReseauxNumerique[0].position;
      }
      if (this.getMarkerFaceReseauxPerso.length) {
        return this.getMarkerFaceReseauxPerso[0].position;
      }
      const myLatLng = { lat: 0, lng: 0 };
      return myLatLng;
    },
  },
  watch: {
    tabValue() {
      this.autoZoom();
    },
  },
  methods: {
    ...Panier.mapMutations({
      setZoomCarto: types.SET_ZOOM_CARTO,
    }),
    updateZoom($event) {
      this.zoomCarto = $event;
    },
    async autoZoom() {
      await this.$refs.mapRef.$mapPromise;
      this.fitBounds();
    },
    fitBounds() {
      const latlngbounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.getMarkerFaceLC.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceLC[i].position);
      }
      for (let i = 0; i < this.getMarkerPanneauNumerique.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerPanneauNumerique[i].position);
      }
      for (let i = 0; i < this.getMarkerPointAddress.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerPointAddress[i].coordonnees);
      }
      for (let i = 0; i < this.getMarkerFaceReseauxLc.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceReseauxLc[i].position);
      }
      for (let i = 0; i < this.getMarkerFaceReseauxTempo.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceReseauxTempo[i].position);
      }
      for (let i = 0; i < this.getMarkerFaceReseauxNumerique.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceReseauxNumerique[i].position);
      }
      for (let i = 0; i < this.getMarkerFaceReseauxPerso.length; (i += 1)) {
        latlngbounds.extend(this.getMarkerFaceReseauxPerso[i].position);
      }
      this.$refs.mapRef.fitBounds(latlngbounds);
    },
    selectMarker(marker) {
      this.selectMarkerFace = !this.selectMarkerFace;
      this.modalDetail = true;
      this.markerSelected = marker;
    },
    selectMarkerReseaux(marker) {
      this.selectMarkerFaceReseaux = !this.selectMarkerFaceReseaux;
      this.modalDetailReseaux = true;
      this.markerSelected = marker;
    },
    async initPoi() {
      const map = await this.$refs.mapRef.$mapPromise;
      const styleMap = new google.maps.StyledMapType(
        STYLE_MAPS_POI_HIDDEN,
        { name: MAP_TYPE_NAME },
      );
      map.mapTypes.set('styled_map', styleMap);
    },
  },
  mounted() {
    this.autoZoom();
  },
};

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/carte.vue